// extracted by mini-css-extract-plugin
module.exports = {"body":"_3dafbb6","button":"_0daf212"};